import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { LastCalculationsType } from '../schema/types';
import { UserCalendarUrl } from '../../UserDashboardUrl';

const getLastCalculations = () =>
  apiClient
    .get<LastCalculationsType>(expand(UserCalendarUrl.LAST_CALCULATIONS), {})
    .then((response) => response.data);

export const useListLastCalculationsQuery = createApiQueryHook(
  ['last-calculations'],
  getLastCalculations,
);
